module.exports = __webpack_public_path__ + "img/arrow-down-blue.ef356609.svg";